import BlueButton from '../../components/blue-button';
import {useRef} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {toggleActionModal} from '../../../reducers/modals-action/actions';
import {closePromotionModal, clickPromotionModal} from '../../../utils/promotions';
import {redeemFreeplayBonus} from '../../../reducers/notifications/actions';
import ModalsLib from '../../../lib/modals';
import PurpleButton from '../../components/purple-button';

export default ({index, details}) => {
    const dispatch = useDispatch();

    // Refs
    const overlay = useRef(),
          modal = useRef();

    const closeAction = (trigger, callback) => {
        if(modal.current) {
            modal.current.classList.remove('animate__slideInUp');
            modal.current.classList.add('animate__slideOutDown');
        }

        if(overlay.current) {
            overlay.current.classList.remove('animate__fadeIn');
            overlay.current.classList.add('animate__fadeOut');
        }

        setTimeout(() => {
            dispatch(toggleActionModal(details));
            
            if(trigger === 'close')
                closePromotionModal('notification-freeplay');
            else
                clickPromotionModal('notification-freeplay', callback);
        }, 500);
    }
    
    return (
        <div className="action-modal-fix social-affiliate">
            <div style={{zIndex: 400 + index}} className="action-modal-overlay animate__animated animate__fadeIn animate__faster" ref={overlay}></div>
            <div style={{zIndex: 400 + index}} className="action-modal-container">
                <div className="action-modal animate__animated animate__slideInUp animate__faster" ref={modal}>
                    <div className="notification-bonus-modal freeplay-modal">
                        <div className="notification-bonus-modal-close" onClick={e => {
                            closeAction('close', () => {

                            });
                        }}>
                            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect width="40" height="40" rx="7" fill="#211D2A"/>
                                <path d="M14 26L26 14" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M26 26L14 14" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </div>
                        <div className="notification-bonus-modal-wrapper">
                            <div className="notification-bonus-modal-container">
                                <div className="notification-bonus-modal-line"></div>
                                <div className="notification-bonus-modal-image">
                                    {
                                        details.game
                                        ? <img src={`${window.location.origin}/source/system/games/squad_new/${details.game}.png`} />
                                        : <img src={`${window.location.origin}/source/system/modals-action/notifications-bonuses/freeplay.png`} />
                                    }
                                </div>
                                <div className="notification-bonus-modal-details">
                                    <div className="notification-bonus-modal-details-title" dangerouslySetInnerHTML={{__html: details.title}}></div>
                                    <div className="notification-bonus-modal-details-text"  dangerouslySetInnerHTML={{__html: details.text}}></div>
                                </div>
                                <div className="notification-bonus-modal-buttons">
                                    <PurpleButton onClick={e => {
                                        closeAction('click', () => {
                                            if(typeof details.game !== 'undefined') 
                                                dispatch(redeemFreeplayBonus(details.notification_id, null));
                                            else
                                                ModalsLib.open('changeGame', {
                                                    redirect: false,
                                                    handler: game => {
                                                        ModalsLib.close();
                                                        dispatch(redeemFreeplayBonus(details.notification_id, game));
                                                    }
                                                }); 
                                        });
                                    }}>Redeem Freeplay</PurpleButton>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <div className="action-modal-body-container">
                        <div className="action-modal-body-top">
                            <div className="close" onClick={e => closeAction('close')}>
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M6 18L18 6" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M18 18L6 6" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </div>
                        </div>
                        <div className="action-modal-body">
                            <div className="social-affiliate-title">You have many <span>subs</span>?<br/>Make money on it!</div>
                            <div className="social-affiliate-image"></div>
                            <BlueButton  onClick={e => {
                                closeAction('click', () => {
                                    window.open('https://t.me/lucksy_affiliate_support_bot');
                                    // ModalsLib.open('wallet'); 
                                });
                            }}>Contact operator</BlueButton>
                            <div className="description">Contact operator and show him your social networks.</div> 
                        </div>
                    </div> */}
                </div>
            </div> 
        </div>
    )
}